import {Component} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {UserApiService} from '../api/user-api.service';
import {ToastrService} from 'ngx-toastr';
import {SpinnerService} from '../shared/services/spinner.service';
import {finalize} from 'rxjs';
import {Router} from '@angular/router';

@Component({
    selector: 'app-recover-password',
    templateUrl: './recover-password.component.html',
    styleUrl: './recover-password.component.css'
})
export class RecoverPasswordComponent {
    recoverForm: FormGroup;
    isSubmitted = false;
    isLoading = false;

    constructor(
        private fb: FormBuilder,
        private userApiService: UserApiService,
        private router: Router,
        private toastr: ToastrService,
        private spinner: SpinnerService
    ) {
        this.recoverForm = this.fb.group({
            email: ['', [Validators.required, Validators.email]]
        });
    }

    get email() {
        return this.recoverForm.get('email');
    }

    onSubmit() {
        this.isSubmitted = true;
        if (this.recoverForm.invalid) {
            return;
        }
        this.isLoading = true;
        this.spinner.show(); // Show spinner while processing
        this.userApiService.forgotPassword({email: this.email?.value}).pipe(
            finalize(() => this.spinner.hide()) // ✅ Hide spinner after outermost call completes
        ).subscribe({
            next: () => {
                this.toastr.success('Password recovery instructions sent to your email.');
                this.isLoading = false;
                this.router.navigate(['/login']);
            },
            error: () => {
                this.toastr.error('Failed to send recovery instructions. Please try again.');
                this.isLoading = false;
            }
        });
    }
}